export function promoCodeReturnData () {
  const state = JSON.parse(sessionStorage.getItem('semprebem:checkout'))

  switch (state.product.alias) {
    case 'residencial':
      return residentialReturn(state)
    default:
      return null
  }
}

function residentialReturn (state) {
  const data = JSON.parse(sessionStorage.getItem('semprebem:residential'))

  data.entities.commission.promoCode = state.promoCode.commission
  data.quotation.promoCode.code = state.plan.promoCode.code
  data.quotation.promoCode.activated = state.promoCode.activated
  data.quotation.promoCode.valid = state.promoCode.activated

  sessionStorage.setItem('semprebem:residential', JSON.stringify(data))
}
